angular.module('IndicatorType').directive('indicatorType', function () {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/IndicatorType/IndicatorTypeForm.html',
    controller: 'IndicatorTypeController',
    scope: {
      indicatorType: '='
    },
    link: function (scope, element, attrs) {

    }
  };
});
